import { Component, Input } from '@angular/core';

@Component({
    selector: 'group-members-indicator',
    template: `
        <div *ngIf="group">
            <mat-icon matTooltip="Members">supervisor_account</mat-icon>
            <div>{{group.membersCount || 0}}</div>
        </div>
    `
})
export class GroupMembersIndicatorComponent  {
    @Input() group;
}